import { createContext, useContext } from 'react';

import type { FormInstance } from 'types/step';
import type { FormOrigin } from 'form/types';

export interface NoteFormOpenParams {
  formInstance: FormInstance;
  isCompleted: boolean;
  origin: FormOrigin;
  noteId: string;
}

export interface NoteFormOpenValue {
  onOpenForm: (params: NoteFormOpenParams) => void;
}

const NoteFormOpenContext = createContext<NoteFormOpenValue | null>(null);

export default NoteFormOpenContext;

export function useNoteFormOpen(): NoteFormOpenValue | null {
  return useContext(NoteFormOpenContext);
}
